"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Oidc = exports.OidcAuthorizationServiceConfiguration = void 0;
const checkSession_js_1 = require("./checkSession.js");
const events_js_1 = require("./events.js");
const initSession_js_1 = require("./initSession.js");
const initWorker_js_1 = require("./initWorker.js");
const login_js_1 = require("./login.js");
const logout_js_1 = require("./logout.js");
const parseTokens_js_1 = require("./parseTokens.js");
const renewTokens_js_1 = require("./renewTokens.js");
const requests_js_1 = require("./requests.js");
const route_utils_js_1 = require("./route-utils.js");
const silentLogin_js_1 = __importStar(require("./silentLogin.js"));
const timer_js_1 = __importDefault(require("./timer.js"));
const user_js_1 = require("./user.js");
class OidcAuthorizationServiceConfiguration {
    constructor(request) {
        this.authorizationEndpoint = request.authorization_endpoint;
        this.tokenEndpoint = request.token_endpoint;
        this.revocationEndpoint = request.revocation_endpoint;
        this.userInfoEndpoint = request.userinfo_endpoint;
        this.checkSessionIframe = request.check_session_iframe;
        this.issuer = request.issuer;
        this.endSessionEndpoint = request.end_session_endpoint;
    }
}
exports.OidcAuthorizationServiceConfiguration = OidcAuthorizationServiceConfiguration;
const oidcDatabase = {};
const oidcFactory = (configuration, name = 'default') => {
    if (oidcDatabase[name]) {
        return oidcDatabase[name];
    }
    oidcDatabase[name] = new Oidc(configuration, name);
    return oidcDatabase[name];
};
const loginCallbackWithAutoTokensRenewAsync = (oidc) => __awaiter(void 0, void 0, void 0, function* () {
    const { parsedTokens, callbackPath } = yield oidc.loginCallbackAsync();
    oidc.timeoutId = (0, renewTokens_js_1.autoRenewTokens)(oidc, parsedTokens.refreshToken, parsedTokens.expiresAt);
    return { callbackPath };
});
const getRandomInt = (max) => {
    return Math.floor(Math.random() * max);
};
class Oidc {
    constructor(configuration, configurationName = 'default') {
        var _a, _b, _c, _d;
        this.initPromise = null;
        this.tryKeepExistingSessionPromise = null;
        this.loginPromise = null;
        this.loginCallbackPromise = null;
        this.loginCallbackWithAutoTokensRenewPromise = null;
        this.userInfoPromise = null;
        this.renewTokensPromise = null;
        this.logoutPromise = null;
        let silent_login_uri = configuration.silent_login_uri;
        if (configuration.silent_redirect_uri && !configuration.silent_login_uri) {
            silent_login_uri = `${configuration.silent_redirect_uri.replace('-callback', '').replace('callback', '')}-login`;
        }
        this.configuration = Object.assign(Object.assign({}, configuration), { silent_login_uri, monitor_session: (_a = configuration.monitor_session) !== null && _a !== void 0 ? _a : false, refresh_time_before_tokens_expiration_in_second: (_b = configuration.refresh_time_before_tokens_expiration_in_second) !== null && _b !== void 0 ? _b : 60, silent_login_timeout: (_c = configuration.silent_login_timeout) !== null && _c !== void 0 ? _c : 12000, token_renew_mode: (_d = configuration.token_renew_mode) !== null && _d !== void 0 ? _d : parseTokens_js_1.TokenRenewMode.access_token_or_id_token_invalid });
        this.configurationName = configurationName;
        this.tokens = null;
        this.userInfo = null;
        this.events = [];
        this.timeoutId = null;
        this.synchroniseTokensAsync.bind(this);
        this.loginCallbackWithAutoTokensRenewAsync.bind(this);
        this.initAsync.bind(this);
        this.loginCallbackAsync.bind(this);
        this.subscribeEvents.bind(this);
        this.removeEventSubscription.bind(this);
        this.publishEvent.bind(this);
        this.destroyAsync.bind(this);
        this.logoutAsync.bind(this);
        this.renewTokensAsync.bind(this);
        this.initAsync(this.configuration.authority, this.configuration.authority_configuration);
    }
    subscribeEvents(func) {
        const id = getRandomInt(9999999999999).toString();
        this.events.push({ id, func });
        return id;
    }
    removeEventSubscription(id) {
        const newEvents = this.events.filter(e => e.id !== id);
        this.events = newEvents;
    }
    publishEvent(eventName, data) {
        this.events.forEach(event => {
            event.func(eventName, data);
        });
    }
    static getOrCreate(configuration, name = 'default') {
        return oidcFactory(configuration, name);
    }
    static get(name = 'default') {
        const isInsideBrowser = (typeof process === 'undefined');
        if (!Object.prototype.hasOwnProperty.call(oidcDatabase, name) && isInsideBrowser) {
            throw Error(`OIDC library does seem initialized.
Please checkout that you are using OIDC hook inside a <OidcProvider configurationName="${name}"></OidcProvider> compoment.`);
        }
        return oidcDatabase[name];
    }
    _silentLoginCallbackFromIFrame() {
        if (this.configuration.silent_redirect_uri && this.configuration.silent_login_uri) {
            const queryParams = (0, route_utils_js_1.getParseQueryStringFromLocation)(window.location.href);
            window.top.postMessage(`${this.configurationName}_oidc_tokens:${JSON.stringify({ tokens: this.tokens, sessionState: queryParams.session_state })}`, window.location.origin);
        }
    }
    _silentLoginErrorCallbackFromIFrame() {
        if (this.configuration.silent_redirect_uri && this.configuration.silent_login_uri) {
            const queryParams = (0, route_utils_js_1.getParseQueryStringFromLocation)(window.location.href);
            window.top.postMessage(`${this.configurationName}_oidc_error:${JSON.stringify({ error: queryParams.error })}`, window.location.origin);
        }
    }
    silentLoginCallbackAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.loginCallbackAsync(true);
                this._silentLoginCallbackFromIFrame();
            }
            catch (error) {
                console.error(error);
                this._silentLoginErrorCallbackFromIFrame();
            }
        });
    }
    initAsync(authority, authorityConfiguration) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.initPromise !== null) {
                return this.initPromise;
            }
            const localFuncAsync = () => __awaiter(this, void 0, void 0, function* () {
                var _a;
                if (authorityConfiguration != null) {
                    return new OidcAuthorizationServiceConfiguration({
                        authorization_endpoint: authorityConfiguration.authorization_endpoint,
                        end_session_endpoint: authorityConfiguration.end_session_endpoint,
                        revocation_endpoint: authorityConfiguration.revocation_endpoint,
                        token_endpoint: authorityConfiguration.token_endpoint,
                        userinfo_endpoint: authorityConfiguration.userinfo_endpoint,
                        check_session_iframe: authorityConfiguration.check_session_iframe,
                        issuer: authorityConfiguration.issuer,
                    });
                }
                const serviceWorker = yield (0, initWorker_js_1.initWorkerAsync)(this.configuration.service_worker_relative_url, this.configurationName);
                const storage = serviceWorker ? window.localStorage : null;
                return yield (0, requests_js_1.fetchFromIssuer)(authority, (_a = this.configuration.authority_time_cache_wellknowurl_in_second) !== null && _a !== void 0 ? _a : 60 * 60, storage);
            });
            this.initPromise = localFuncAsync();
            return this.initPromise.then((result) => {
                this.initPromise = null;
                return result;
            });
        });
    }
    tryKeepExistingSessionAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.tryKeepExistingSessionPromise !== null) {
                return this.tryKeepExistingSessionPromise;
            }
            const funcAsync = () => __awaiter(this, void 0, void 0, function* () {
                var _a;
                let serviceWorker;
                if (this.tokens != null) {
                    return false;
                }
                this.publishEvent(events_js_1.eventNames.tryKeepExistingSessionAsync_begin, {});
                try {
                    const configuration = this.configuration;
                    const oidcServerConfiguration = yield this.initAsync(configuration.authority, configuration.authority_configuration);
                    serviceWorker = yield (0, initWorker_js_1.initWorkerAsync)(configuration.service_worker_relative_url, this.configurationName);
                    if (serviceWorker) {
                        const { tokens } = yield serviceWorker.initAsync(oidcServerConfiguration, 'tryKeepExistingSessionAsync', configuration);
                        if (tokens) {
                            serviceWorker.startKeepAliveServiceWorker();
                            // @ts-ignore
                            this.tokens = tokens;
                            const getLoginParams = serviceWorker.getLoginParams(this.configurationName);
                            // @ts-ignore
                            this.timeoutId = (0, renewTokens_js_1.autoRenewTokens)(this, this.tokens.refreshToken, this.tokens.expiresAt, getLoginParams.extras);
                            const sessionState = yield serviceWorker.getSessionStateAsync();
                            // @ts-ignore
                            yield this.startCheckSessionAsync(oidcServerConfiguration.check_session_iframe, configuration.client_id, sessionState);
                            this.publishEvent(events_js_1.eventNames.tryKeepExistingSessionAsync_end, {
                                success: true,
                                message: 'tokens inside ServiceWorker are valid',
                            });
                            return true;
                        }
                        this.publishEvent(events_js_1.eventNames.tryKeepExistingSessionAsync_end, {
                            success: false,
                            message: 'no exiting session found',
                        });
                    }
                    else {
                        if (configuration.service_worker_relative_url) {
                            this.publishEvent(events_js_1.eventNames.service_worker_not_supported_by_browser, {
                                message: 'service worker is not supported by this browser',
                            });
                        }
                        const session = (0, initSession_js_1.initSession)(this.configurationName, (_a = configuration.storage) !== null && _a !== void 0 ? _a : sessionStorage);
                        const { tokens } = yield session.initAsync();
                        if (tokens) {
                            // @ts-ignore
                            this.tokens = (0, parseTokens_js_1.setTokens)(tokens, null, configuration.token_renew_mode);
                            const getLoginParams = session.getLoginParams(this.configurationName);
                            // @ts-ignore
                            this.timeoutId = (0, renewTokens_js_1.autoRenewTokens)(this, tokens.refreshToken, this.tokens.expiresAt, getLoginParams.extras);
                            const sessionState = yield session.getSessionStateAsync();
                            // @ts-ignore
                            yield this.startCheckSessionAsync(oidcServerConfiguration.check_session_iframe, configuration.client_id, sessionState);
                            this.publishEvent(events_js_1.eventNames.tryKeepExistingSessionAsync_end, {
                                success: true,
                                message: 'tokens inside storage are valid',
                            });
                            return true;
                        }
                    }
                    this.publishEvent(events_js_1.eventNames.tryKeepExistingSessionAsync_end, {
                        success: false,
                        message: serviceWorker ? 'service worker sessions not retrieved' : 'session storage sessions not retrieved',
                    });
                    return false;
                }
                catch (exception) {
                    console.error(exception);
                    if (serviceWorker) {
                        yield serviceWorker.clearAsync();
                    }
                    this.publishEvent(events_js_1.eventNames.tryKeepExistingSessionAsync_error, 'tokens inside ServiceWorker are invalid');
                    return false;
                }
            });
            this.tryKeepExistingSessionPromise = funcAsync();
            return this.tryKeepExistingSessionPromise.then((result) => {
                this.tryKeepExistingSessionPromise = null;
                return result;
            });
        });
    }
    startCheckSessionAsync(checkSessionIFrameUri, clientId, sessionState, isSilentSignin = false) {
        return __awaiter(this, void 0, void 0, function* () {
            yield (0, checkSession_js_1.startCheckSessionAsync)(this, oidcDatabase, this.configuration)(checkSessionIFrameUri, clientId, sessionState, isSilentSignin);
        });
    }
    loginAsync(callbackPath = undefined, extras = null, isSilentSignin = false, scope = undefined, silentLoginOnly = false) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.loginPromise !== null) {
                return this.loginPromise;
            }
            if (silentLoginOnly) {
                return (0, silentLogin_js_1.default)(window, this.configurationName, this.configuration, this.publishEvent.bind(this), this)(extras, scope);
            }
            this.loginPromise = (0, login_js_1.defaultLoginAsync)(window, this.configurationName, this.configuration, this.publishEvent.bind(this), this.initAsync.bind(this))(callbackPath, extras, isSilentSignin, scope);
            return this.loginPromise.then(result => {
                this.loginPromise = null;
                return result;
            });
        });
    }
    loginCallbackAsync(isSilenSignin = false) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.loginCallbackPromise !== null) {
                return this.loginCallbackPromise;
            }
            const loginCallbackLocalAsync = () => __awaiter(this, void 0, void 0, function* () {
                const response = yield (0, login_js_1.loginCallbackAsync)(this)(isSilenSignin);
                // @ts-ignore
                const parsedTokens = response.tokens;
                // @ts-ignore
                this.tokens = parsedTokens;
                const serviceWorker = yield (0, initWorker_js_1.initWorkerAsync)(this.configuration.service_worker_relative_url, this.configurationName);
                if (!serviceWorker) {
                    const session = (0, initSession_js_1.initSession)(this.configurationName, this.configuration.storage);
                    session.setTokens(parsedTokens);
                }
                this.publishEvent(Oidc.eventNames.token_aquired, parsedTokens);
                // @ts-ignore
                return { parsedTokens, state: response.state, callbackPath: response.callbackPath };
            });
            this.loginCallbackPromise = loginCallbackLocalAsync();
            return this.loginCallbackPromise.then(result => {
                this.loginCallbackPromise = null;
                return result;
            });
        });
    }
    synchroniseTokensAsync(refreshToken, index = 0, forceRefresh = false, extras = null, updateTokens) {
        return __awaiter(this, void 0, void 0, function* () {
            while (!navigator.onLine && document.hidden) {
                yield (0, initWorker_js_1.sleepAsync)(1000);
                this.publishEvent(events_js_1.eventNames.refreshTokensAsync, { message: 'wait because navigator is offline and hidden' });
            }
            let numberTryOnline = 6;
            while (!navigator.onLine && numberTryOnline > 0) {
                yield (0, initWorker_js_1.sleepAsync)(1000);
                numberTryOnline--;
                this.publishEvent(events_js_1.eventNames.refreshTokensAsync, { message: `wait because navigator is offline try ${numberTryOnline}` });
            }
            let numberTryHidden = Math.floor(Math.random() * 15) + 10;
            while (document.hidden && numberTryHidden > 0) {
                yield (0, initWorker_js_1.sleepAsync)(1000);
                numberTryHidden--;
                this.publishEvent(events_js_1.eventNames.refreshTokensAsync, { message: `wait because navigator is hidden try ${numberTryHidden}` });
            }
            const isDocumentHidden = document.hidden;
            const nextIndex = isDocumentHidden ? index : index + 1;
            if (!extras) {
                extras = {};
            }
            const configuration = this.configuration;
            const silentLoginAsync = (extras, state, scope = null) => {
                return (0, silentLogin_js_1._silentLoginAsync)(this.configurationName, this.configuration, this.publishEvent.bind(this))(extras, state, scope);
            };
            const localsilentLoginAsync = () => __awaiter(this, void 0, void 0, function* () {
                try {
                    let loginParams;
                    const serviceWorker = yield (0, initWorker_js_1.initWorkerAsync)(configuration.service_worker_relative_url, this.configurationName);
                    if (serviceWorker) {
                        loginParams = serviceWorker.getLoginParams(this.configurationName);
                    }
                    else {
                        const session = (0, initSession_js_1.initSession)(this.configurationName, configuration.storage);
                        loginParams = session.getLoginParams(this.configurationName);
                    }
                    const silent_token_response = yield silentLoginAsync(Object.assign(Object.assign(Object.assign({}, loginParams.extras), extras), { prompt: 'none' }), loginParams.state);
                    if (silent_token_response) {
                        updateTokens(silent_token_response.tokens);
                        this.publishEvent(Oidc.eventNames.token_renewed, {});
                        return { tokens: silent_token_response.tokens, status: 'LOGGED' };
                    }
                }
                catch (exceptionSilent) {
                    console.error(exceptionSilent);
                    this.publishEvent(events_js_1.eventNames.refreshTokensAsync_silent_error, { message: 'exceptionSilent', exception: exceptionSilent.message });
                    if (exceptionSilent && exceptionSilent.message && exceptionSilent.message.startsWith('oidc')) {
                        updateTokens(null);
                        this.publishEvent(events_js_1.eventNames.refreshTokensAsync_error, { message: 'refresh token silent' });
                        return { tokens: null, status: 'SESSION_LOST' };
                    }
                }
                this.publishEvent(events_js_1.eventNames.refreshTokensAsync_error, { message: 'refresh token silent return' });
                return yield this.synchroniseTokensAsync(null, nextIndex, forceRefresh, extras, updateTokens);
            });
            if (index > 4) {
                updateTokens(null);
                this.publishEvent(events_js_1.eventNames.refreshTokensAsync_error, { message: 'refresh token' });
                return { tokens: null, status: 'SESSION_LOST' };
            }
            try {
                const { status, tokens, nonce } = yield this.syncTokensInfoAsync(configuration, this.configurationName, this.tokens, forceRefresh);
                switch (status) {
                    case 'SESSION_LOST':
                        updateTokens(null);
                        this.publishEvent(events_js_1.eventNames.refreshTokensAsync_error, { message: 'refresh token session lost' });
                        return { tokens: null, status: 'SESSION_LOST' };
                    case 'NOT_CONNECTED':
                        updateTokens(null);
                        return { tokens: null, status: null };
                    case 'TOKENS_VALID':
                        updateTokens(tokens);
                        return { tokens, status: 'LOGGED_IN' };
                    case 'TOKEN_UPDATED_BY_ANOTHER_TAB_TOKENS_VALID':
                        updateTokens(tokens);
                        this.publishEvent(Oidc.eventNames.token_renewed, { reason: 'TOKEN_UPDATED_BY_ANOTHER_TAB_TOKENS_VALID' });
                        return { tokens, status: 'LOGGED_IN' };
                    case 'LOGOUT_FROM_ANOTHER_TAB':
                        updateTokens(null);
                        this.publishEvent(events_js_1.eventNames.logout_from_another_tab, { status: 'session syncTokensAsync' });
                        return { tokens: null, status: 'LOGGED_OUT' };
                    case 'REQUIRE_SYNC_TOKENS':
                        this.publishEvent(events_js_1.eventNames.refreshTokensAsync_begin, { refreshToken, status, tryNumber: index });
                        return yield localsilentLoginAsync();
                    default: {
                        this.publishEvent(events_js_1.eventNames.refreshTokensAsync_begin, { refreshToken, status, tryNumber: index });
                        if (!refreshToken) {
                            return yield localsilentLoginAsync();
                        }
                        const clientId = configuration.client_id;
                        const redirectUri = configuration.redirect_uri;
                        const authority = configuration.authority;
                        const tokenExtras = configuration.token_request_extras ? configuration.token_request_extras : {};
                        const finalExtras = Object.assign({}, tokenExtras);
                        for (const [key, value] of Object.entries(extras)) {
                            if (key.endsWith(':token_request')) {
                                finalExtras[key.replace(':token_request', '')] = value;
                            }
                        }
                        const localFunctionAsync = () => __awaiter(this, void 0, void 0, function* () {
                            const details = {
                                client_id: clientId,
                                redirect_uri: redirectUri,
                                grant_type: 'refresh_token',
                                refresh_token: tokens.refreshToken,
                            };
                            const oidcServerConfiguration = yield this.initAsync(authority, configuration.authority_configuration);
                            const timeoutMs = document.hidden ? 10000 : 30000 * 10;
                            const tokenResponse = yield (0, requests_js_1.performTokenRequestAsync)(oidcServerConfiguration.tokenEndpoint, details, finalExtras, tokens, configuration.token_renew_mode, timeoutMs);
                            if (tokenResponse.success) {
                                const { isValid, reason } = (0, parseTokens_js_1.isTokensOidcValid)(tokenResponse.data, nonce.nonce, oidcServerConfiguration);
                                if (!isValid) {
                                    updateTokens(null);
                                    this.publishEvent(events_js_1.eventNames.refreshTokensAsync_error, { message: `refresh token return not valid tokens, reason: ${reason}` });
                                    return { tokens: null, status: 'SESSION_LOST' };
                                }
                                updateTokens(tokenResponse.data);
                                this.publishEvent(events_js_1.eventNames.refreshTokensAsync_end, { success: tokenResponse.success });
                                this.publishEvent(Oidc.eventNames.token_renewed, { reason: 'REFRESH_TOKEN' });
                                return { tokens: tokenResponse.data, status: 'LOGGED_IN' };
                            }
                            else {
                                this.publishEvent(events_js_1.eventNames.refreshTokensAsync_silent_error, {
                                    message: 'bad request',
                                    tokenResponse,
                                });
                                return yield this.synchroniseTokensAsync(refreshToken, nextIndex, forceRefresh, extras, updateTokens);
                            }
                        });
                        return yield localFunctionAsync();
                    }
                }
            }
            catch (exception) {
                console.error(exception);
                this.publishEvent(events_js_1.eventNames.refreshTokensAsync_silent_error, { message: 'exception', exception: exception.message });
                return this.synchroniseTokensAsync(refreshToken, nextIndex, forceRefresh, extras, updateTokens);
            }
        });
    }
    syncTokensInfoAsync(configuration, configurationName, currentTokens, forceRefresh = false) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            // Service Worker can be killed by the browser (when it wants,for example after 10 seconds of inactivity, so we retreieve the session if it happen)
            // const configuration = this.configuration;
            const nullNonce = { nonce: null };
            if (!currentTokens) {
                return { tokens: null, status: 'NOT_CONNECTED', nonce: nullNonce };
            }
            let nonce = nullNonce;
            const oidcServerConfiguration = yield this.initAsync(configuration.authority, configuration.authority_configuration);
            const serviceWorker = yield (0, initWorker_js_1.initWorkerAsync)(configuration.service_worker_relative_url, configurationName);
            if (serviceWorker) {
                const { status, tokens } = yield serviceWorker.initAsync(oidcServerConfiguration, 'syncTokensAsync', configuration);
                if (status === 'LOGGED_OUT') {
                    return { tokens: null, status: 'LOGOUT_FROM_ANOTHER_TAB', nonce: nullNonce };
                }
                else if (status === 'SESSIONS_LOST') {
                    return { tokens: null, status: 'SESSIONS_LOST', nonce: nullNonce };
                }
                else if (!status || !tokens) {
                    return { tokens: null, status: 'REQUIRE_SYNC_TOKENS', nonce: nullNonce };
                }
                else if (tokens.issuedAt !== currentTokens.issuedAt) {
                    const timeLeft = (0, parseTokens_js_1.computeTimeLeft)(configuration.refresh_time_before_tokens_expiration_in_second, tokens.expiresAt);
                    const status = (timeLeft > 0) ? 'TOKEN_UPDATED_BY_ANOTHER_TAB_TOKENS_VALID' : 'TOKEN_UPDATED_BY_ANOTHER_TAB_TOKENS_INVALID';
                    const nonce = yield serviceWorker.getNonceAsync();
                    return { tokens, status, nonce };
                }
                nonce = yield serviceWorker.getNonceAsync();
            }
            else {
                const session = (0, initSession_js_1.initSession)(configurationName, (_a = configuration.storage) !== null && _a !== void 0 ? _a : sessionStorage);
                const { tokens, status } = yield session.initAsync();
                if (!tokens) {
                    return { tokens: null, status: 'LOGOUT_FROM_ANOTHER_TAB', nonce: nullNonce };
                }
                else if (status === 'SESSIONS_LOST') {
                    return { tokens: null, status: 'SESSIONS_LOST', nonce: nullNonce };
                }
                else if (tokens.issuedAt !== currentTokens.issuedAt) {
                    const timeLeft = (0, parseTokens_js_1.computeTimeLeft)(configuration.refresh_time_before_tokens_expiration_in_second, tokens.expiresAt);
                    const status = (timeLeft > 0) ? 'TOKEN_UPDATED_BY_ANOTHER_TAB_TOKENS_VALID' : 'TOKEN_UPDATED_BY_ANOTHER_TAB_TOKENS_INVALID';
                    const nonce = yield session.getNonceAsync();
                    return { tokens, status, nonce };
                }
                nonce = yield session.getNonceAsync();
            }
            const timeLeft = (0, parseTokens_js_1.computeTimeLeft)(configuration.refresh_time_before_tokens_expiration_in_second, currentTokens.expiresAt);
            const status = (timeLeft > 0) ? 'TOKENS_VALID' : 'TOKENS_INVALID';
            if (forceRefresh) {
                return { tokens: currentTokens, status: 'FORCE_REFRESH', nonce };
            }
            return { tokens: currentTokens, status, nonce };
        });
    }
    loginCallbackWithAutoTokensRenewAsync() {
        if (this.loginCallbackWithAutoTokensRenewPromise !== null) {
            return this.loginCallbackWithAutoTokensRenewPromise;
        }
        this.loginCallbackWithAutoTokensRenewPromise = loginCallbackWithAutoTokensRenewAsync(this);
        return this.loginCallbackWithAutoTokensRenewPromise.then(result => {
            this.loginCallbackWithAutoTokensRenewPromise = null;
            return result;
        });
    }
    userInfoAsync() {
        if (this.userInfoPromise !== null) {
            return this.userInfoPromise;
        }
        this.userInfoPromise = (0, user_js_1.userInfoAsync)(this);
        return this.userInfoPromise.then(result => {
            this.userInfoPromise = null;
            return result;
        });
    }
    renewTokensAsync(extras = null) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.renewTokensPromise !== null) {
                return this.renewTokensPromise;
            }
            if (!this.timeoutId) {
                return;
            }
            timer_js_1.default.clearTimeout(this.timeoutId);
            // @ts-ignore
            this.renewTokensPromise = (0, renewTokens_js_1.renewTokensAndStartTimerAsync)(this, this.tokens.refreshToken, true, extras);
            return this.renewTokensPromise.then(result => {
                this.renewTokensPromise = null;
                return result;
            });
        });
    }
    destroyAsync(status) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield (0, logout_js_1.destroyAsync)(this)(status);
        });
    }
    logoutSameTabAsync(clientId, sub) {
        return __awaiter(this, void 0, void 0, function* () {
            // @ts-ignore
            if (this.configuration.monitor_session && this.configuration.client_id === clientId && sub && this.tokens && this.tokens.idTokenPayload && this.tokens.idTokenPayload.sub === sub) {
                this.publishEvent(events_js_1.eventNames.logout_from_same_tab, { message: sub });
                yield this.destroyAsync('LOGGED_OUT');
            }
        });
    }
    logoutOtherTabAsync(clientId, sub) {
        return __awaiter(this, void 0, void 0, function* () {
            // @ts-ignore
            if (this.configuration.monitor_session && this.configuration.client_id === clientId && sub && this.tokens && this.tokens.idTokenPayload && this.tokens.idTokenPayload.sub === sub) {
                yield this.destroyAsync('LOGGED_OUT');
                this.publishEvent(events_js_1.eventNames.logout_from_another_tab, { message: 'SessionMonitor', sub });
            }
        });
    }
    logoutAsync(callbackPathOrUrl = undefined, extras = null) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.logoutPromise) {
                return this.logoutPromise;
            }
            this.logoutPromise = (0, logout_js_1.logoutAsync)(this, oidcDatabase)(callbackPathOrUrl, extras);
            return this.logoutPromise.then(result => {
                this.logoutPromise = null;
                return result;
            });
        });
    }
}
exports.Oidc = Oidc;
Oidc.eventNames = events_js_1.eventNames;
exports.default = Oidc;
//# sourceMappingURL=oidc.js.map